import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IpoDataService {
  private currentRowData: any;

  setCurrentRowData(row: any) {
    this.currentRowData = row;
  }

  getCurrentRowData() {
    return this.currentRowData;
  }
}
